import {
  EntityWithChildIds,
  PageEntityInterface,
} from '../types/base-entity-interface'

export function isEntityWithChildIds(
  entity: PageEntityInterface,
): entity is EntityWithChildIds {
  return entity.childIds !== undefined
}
